// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34wns","colBig":"styles_colBig__2k_OO","colSmall":"styles_colSmall__3VBY_"};